import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { of } from 'rxjs';

import { AccountService } from '../../services/account.service';
import { Candidate } from '../../models/candidate.model';
import { AuthenticationService } from '../../services/authentication.service';
import { SearchFormSharedService } from '../search/searchForm/searchForm.shared.service';
import { HelpersService } from '../../helpers/helpers.service';
import { CorporateConfig } from '../../corporate.config';
import { TenantService } from 'src/app/services/tenant.service';
import { AppConfig } from 'src/app/app.config';
import { Menu } from 'src/app/models/menu.model';
import { AccountApplicationData } from 'src/app/models/accountApplicationData.model';

@Component({
    selector: 'nav-menu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css']
})
export class NavMenuComponent implements OnInit {

    public user: Candidate;
    public CandidateLink: string;
    public ClientsLink: string;
    public ContactUsLink: string;
    public NewsAndEventsLink: string;
    public AboutUsLink: string;
    tenantName: string;

    isAccountApplicationMode = AppConfig.getAccountMode;
    accountModeUrl = AppConfig.getAccountModeUrl;

    loggedInMenu: Menu[] = [
        {
          title: "Job Search",
          url: `${this.accountModeUrl}search`,
          icon: "search",
          id: 1,
        },
        {
          title: "Dashboard",
          url: "dashboard",
          icon: "dashboard",
          id: 2,
        },
      ];

    @ViewChild('menuToggler') menuToggler: ElementRef;
    @ViewChild('mobileLinks') mobileLinks: ElementRef;

    displayLoggedInNavbar$ = this.authenticationService.isUserLoggedin;
    cmsData: any;

    constructor(
        private helpersService: HelpersService,
        private accountService: AccountService,
        private authenticationService: AuthenticationService,
        private router: Router,
        public searchFormSharedService: SearchFormSharedService,
        private tenantService: TenantService    ) {
    }

    ngOnInit() {
        this.tenantService.getTenantDetails()
            .subscribe(res => {
                this.tenantName = res.TenantDisplayName;
            });

             this.tenantService.getCmsFooter().subscribe({
                  next: (cms: AccountApplicationData) => {
                    this.parseCmsContent(cms);
                    this.cmsData = cms.header;
                  },
                  error: (err: Error) =>
                    console.log("Error getting data from CMS", err.message),
                });

        this.CandidateLink = this.helpersService.getPageContent(CorporateConfig.CandidateLink);
        this.ClientsLink = this.helpersService.getPageContent(CorporateConfig.ClientsLink);
        this.ContactUsLink = this.helpersService.getPageContent(CorporateConfig.ContactUsLink);
        this.NewsAndEventsLink = this.helpersService.getPageContent(CorporateConfig.NewsAndEventsLink);
        this.AboutUsLink = this.helpersService.getPageContent(CorporateConfig.AboutUsLink);

        this.authenticationService.isUserLoggedin.subscribe({
            next: res => {
                if (res) {
                    this.GetCandidate();
                  }
             },
        });       
    }

    logOut() {
        this.authenticationService.logout().subscribe({
            next: () => {
                this.authenticationService.isUserLoggedin.next(false);
                this.router.navigate(['/account/login']);
            },
            error: (error) => {
                // User already logged out
                if (error.status === 401) {
                    this.authenticationService.isUserLoggedin.next(false);
                    this.router.navigate(['/account/login']);
                }
            }
        });
    }

    toggleCollapse() {
        let classes = this.mobileLinks.nativeElement.classList as string[];
        if (classes.length > 2) {
            this.menuToggler.nativeElement.click();
        }
        this.showMenuButton();
    }

    getAllJobs() {
        this.searchFormSharedService.getAllJobs();
    }

    showCloseButton(): void {
        document.getElementById("menu-open-button").classList.add("d-none");
        document.getElementById("menu-close-button").classList.remove("d-none");
        document.getElementById("menu-open-button-text").classList.add("d-none");
        document.getElementById("menu-close-button-text").classList.remove("d-none");
    }

    showMenuButton():void {
        document.getElementById("menu-open-button").classList.remove("d-none");
        document.getElementById("menu-close-button").classList.add("d-none");
        document.getElementById("menu-open-button-text").classList.remove("d-none");
        document.getElementById("menu-close-button-text").classList.add("d-none");
    }
        

    private GetCandidate() {
        return this.accountService.getCandidate().subscribe({
            next: res => this.getUser(res),
            error: () => of(false)
        });
    }

    private getUser(input: Candidate) {
        this.user = input;
    }

    private parseCmsContent(cms: AccountApplicationData) {
        var parser = new DOMParser();
        cms.header.menu.forEach(x => {
            if (x.title === "Jobs") {
              (x.title = "Job search", x.url =`${this.accountModeUrl}search`);
            }
          x.title = parser.parseFromString(x.title, "text/html").body.textContent;
        });
      }
}
